import { css } from '@emotion/react';
import { useDevToolsStore } from '@frontend/devtools';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../../hooks/use-check-payments-enabled';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { ScheduleRequestDetails } from '../schedule-request-item-details';
import { ScheduleRequestItemHeader, ScheduleRequestItemHeaderProps } from '../schedule-request-item-header';

export const SchedulePulseRequestListItem = (props: ScheduleRequestItemHeaderProps & { className?: string }) => {
  const { listItem } = props;
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(listItem.locationId);
  const isDebugModeOn = useDevToolsStore((state) => state.options.isDebugModeOn);

  return (
    <Accordion.Item
      trackingId={ScheduleRequestsTrackingIds.requestListItemAccordion}
      value={listItem?.id ?? ''}
      key={listItem?.id ?? ''}
      className={props.className}
      css={[styles.accordianItem]}
    >
      <Accordion.Header
        css={isDebugModeOn && listItem.linkHash === 'v2' ? { backgroundColor: theme.colors.critical10 } : undefined}
      >
        <ScheduleRequestItemHeader {...props} />
      </Accordion.Header>

      <Accordion.Body>
        <ScheduleRequestDetails
          listItem={listItem}
          requestVersion={listItem.linkHash || ''}
          scheduleRequestId={listItem.id ?? ''}
          locationId={listItem.locationId ?? ''}
          isPaymentsEnabled={isPaymentsEnabled}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
};

const styles = {
  accordianItem: css`
    border-bottom: 1px solid ${theme.colors.neutral10};
  `,
};
